import { DATE_BUILD, NOTES_VERSION, VERSION } from '@/lib/version';

/** Pastille de version, en bas à gauche de toutes les pages. Survol = nouveautés de la version. */
export function VersionBadge() {
  const notes = NOTES_VERSION[VERSION] ?? [];
  return (
    <div
      className="pointer-events-auto fixed bottom-2 left-2 z-50 rounded-md border bg-background/90 px-2 py-0.5 text-[11px] text-muted-foreground shadow-sm print:hidden"
      title={[`Les Experts ${VERSION}`, DATE_BUILD && `Lancé le ${DATE_BUILD}`, ...notes.map((n) => `• ${n}`)].filter(Boolean).join('\n')}
    >
      Les Experts <b className="text-foreground">{VERSION}</b>{DATE_BUILD && <> · {DATE_BUILD}</>}
    </div>
  );
}
